import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { RouteDirectionEntity } from '../../schedule.model';
import { SchedulePartialStoreState } from '../schedule.reducer';
import { RouteDirectionActions } from './route-direction.action';
import * as RouteDirectionSelector from './route-direction.selectors';

@Injectable()
export class RouteDirectionFacade {
    selectedRouteDirectionId$: Observable<string> = this.store.select(RouteDirectionSelector.getSelectedDirectionId);

    constructor(private store: NgRedux<SchedulePartialStoreState>, private actions: RouteDirectionActions) {}

    getRouteDirections(routeId: number): Observable<RouteDirectionEntity> {
        return this.store.select(RouteDirectionSelector.getRouteDirections(routeId));
    }

    setSelectedRouteDirection(id) {
        this.store.dispatch(this.actions.setSelectedRouteDirection(id));
    }
}
